module.exports = __webpack_public_path__ + "img/qcore.edad7cb2.png";